/**
 * S4 Magasin - Services Accordion
 */

document.addEventListener("DOMContentLoaded", function () {
	const serviceItems = document.querySelectorAll(".service-item");

	serviceItems.forEach(function (item) {
		const question = item.querySelector(".service-question");
		const answer = item.querySelector(".service-answer");

		if (question && answer) {
			question.addEventListener("click", function () {
				const isOpen = item.classList.contains("active");

				// Close all other services
				serviceItems.forEach(function (otherItem) {
					otherItem.classList.remove("active");
					const otherAnswer = otherItem.querySelector(".service-answer");
					if (otherAnswer) {
						otherAnswer.style.maxHeight = null;
					}
				});

				// Toggle current service
				if (!isOpen) {
					item.classList.add("active");
					answer.style.maxHeight = answer.scrollHeight + "px";
				}
			});
		}
	});
});
